import { useJsApiLoader, type Libraries } from "@react-google-maps/api";
import CONFIG from "config/config";

// The Google Maps script is loaded once as a singleton; every loader call must
// pass identical options or it rejects. These are shared by all targeting map
// layers (H2H pins, D2D polygons) so the options can never drift apart. The
// version is pinned to match the legacy maps (DrawingManager needs 3.64).
export const GOOGLE_MAPS_LIBRARIES: Libraries = ["geometry", "places", "drawing"];

export const useTargetingMapLoader = () =>
  useJsApiLoader({
    googleMapsApiKey: CONFIG.GOOGLE_API_KEY,
    libraries: GOOGLE_MAPS_LIBRARIES,
    language: "en",
    version: "3.64",
  });

export const mapContainerStyle = { width: "100%", height: "100%" };

export const baseMapOptions: google.maps.MapOptions = {
  disableDefaultUI: true,
  zoomControl: true,
  clickableIcons: false,
};
